// extracted by mini-css-extract-plugin
module.exports = {"quantity-counter":"subscriptionModal_quantity-counter__2_ZM6"};